import { render } from "./TechnologyPartners.vue?vue&type=template&id=7005e1f6&scoped=true"
import script from "./TechnologyPartners.vue?vue&type=script&lang=js"
export * from "./TechnologyPartners.vue?vue&type=script&lang=js"

import "./TechnologyPartners.vue?vue&type=style&index=0&id=7005e1f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7005e1f6"]])

export default __exports__